import "@/assets/scss/index.scss";
import "@/plugins/bootstrap-vue";
import "@/plugins/install-http";
import "@babel/polyfill";
import "animate.css";
import "mutationobserver-shim";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";

import store from "@/store";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faClock } from "@fortawesome/free-regular-svg-icons";
import { faMicrosoft } from "@fortawesome/free-brands-svg-icons";
import { faLock, faSearch, faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(faClock);
library.add(faUser);
library.add(faLock);
library.add(faSearch);
library.add(faMicrosoft);

Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
